export const LAST_PERSPECTIVE_USER_PREFERENCE_KEY = 'console.lastPerspective';
export const FAVORITES_USER_PREFERENCE_KEY = 'console.favorites';
export const HIDE_USER_WORKLOAD_NOTIFICATIONS_USER_PREFERENCE_KEY =
  'console.hideUserWorkloadNotifications';

export const FLAG_DEVELOPER_PERSPECTIVE = 'DEVELOPER_PERSPECTIVE';
export const FLAG_CAN_GET_CONSOLE_OPERATOR_CONFIG = 'CAN_GET_CONSOLE_OPERATOR_CONFIG';
export const FLAG_TECH_PREVIEW = 'TECH_PREVIEW';
export const FLAG_INTEGRATION_TEST = 'INTEGRATION_TEST';

export const ACM_PERSPECTIVE_ID = 'acm';
/** User settings key for the node management v1 (node groups) toggle */
export const NODE_MGMT_V1_ENABLED_USER_SETTING_KEY = 'console.nodeMgmtV1.enabled';

/** Feature flag for node groups management UI (Nodes list + node details), gated by tech preview + user preference */
export const FLAG_NODE_MGMT_V1 = 'NODE_MGMT_V1';
